/**
 * Escrituras de la lección high-priest-2 (pastoreo). Texto según churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const highPriest2TrainingScripturesEs: Scripture[] = [
  {
    id: 'john-21-15-17',
    reference: 'Juan 21:15–17',
    text:
      'Y cuando hubieron comido, Jesús le dijo a Simón Pedro: Simón hijo de Jonás, ¿me amas más que estos? Pedro le contestó: Sí, Señor, tú sabes que te amo. Él le dijo: Apacienta mis corderos. Volvió a decirle la segunda vez: Simón hijo de Jonás, ¿me amas? Le respondió: Sí, Señor, tú sabes que te amo. Le dijo: Apacienta mis ovejas. Le dijo la tercera vez: Simón hijo de Jonás, ¿me amas? Se entristeció Pedro de que le dijese por tercera vez: ¿Me amas?, y le dijo: Señor, tú sabes todas las cosas; tú sabes que te amo. Jesús le dijo: Apacienta mis ovejas.',
    verses: [
      {
        verse: 15,
        text: 'Y cuando hubieron comido, Jesús le dijo a Simón Pedro: Simón hijo de Jonás, ¿me amas más que estos? Pedro le contestó: Sí, Señor, tú sabes que te amo. Él le dijo: Apacienta mis corderos.',
      },
      {
        verse: 16,
        text: 'Volvió a decirle la segunda vez: Simón hijo de Jonás, ¿me amas? Le respondió: Sí, Señor, tú sabes que te amo. Le dijo: Apacienta mis ovejas.',
      },
      {
        verse: 17,
        text: 'Le dijo la tercera vez: Simón hijo de Jonás, ¿me amas? Se entristeció Pedro de que le dijese por tercera vez: ¿Me amas?, y le dijo: Señor, tú sabes todas las cosas; tú sabes que te amo. Jesús le dijo: Apacienta mis ovejas.',
      },
    ],
    context: 'Jesús encarga a Pedro apacentar el rebaño como expresión de amor.',
  },
  {
    id: 'ephesians-4-29',
    reference: 'Efesios 4:29',
    text:
      'Ninguna palabra corrompida salga de vuestra boca, sino la que sea buena para la necesaria edificación, a fin de impartir gracia a los oyentes.',
    verses: [
      {
        verse: 29,
        text: 'Ninguna palabra corrompida salga de vuestra boca, sino la que sea buena para la necesaria edificación, a fin de impartir gracia a los oyentes.',
      },
    ],
    context: 'Hablar para edificar y dar gracia a quienes escuchan.',
  },
  {
    id: 'alma-7-11-12',
    reference: 'Alma 7:11–12',
    text:
      'Y él saldrá, sufriendo dolores, aflicciones y tentaciones de todas clases; y esto para que se cumpla la palabra que dice: Tomará sobre sí los dolores y las enfermedades de su pueblo. Y tomará sobre sí la muerte, para soltar las ligaduras de la muerte que sujetan a su pueblo; y sus debilidades tomará él sobre sí, para que sus entrañas sean llenas de misericordia, según la carne, a fin de que según la carne sepa cómo socorrer a los de su pueblo, de acuerdo con las debilidades de ellos.',
    verses: [
      {
        verse: 11,
        text: 'Y él saldrá, sufriendo dolores, aflicciones y tentaciones de todas clases; y esto para que se cumpla la palabra que dice: Tomará sobre sí los dolores y las enfermedades de su pueblo.',
      },
      {
        verse: 12,
        text: 'Y tomará sobre sí la muerte, para soltar las ligaduras de la muerte que sujetan a su pueblo; y sus debilidades tomará él sobre sí, para que sus entrañas sean llenas de misericordia, según la carne, a fin de que según la carne sepa cómo socorrer a los de su pueblo, de acuerdo con las debilidades de ellos.',
      },
    ],
    context: 'Cristo toma sobre sí nuestras aflicciones para poder socorrer según nuestras debilidades.',
  },
];
